import { Toaster as Sonner, toast } from 'sonner';
import { useTheme } from '@/lib/theme';

export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'group border-border bg-card text-card-foreground shadow-lg',
        },
      }}
    />
  );
}

export { toast };
